import React from "react";
import { Box, Paper, Card, Typography } from "@mui/material";

const RankingCard = ({ title, rank, total, label, iconSvg }) => {
    return (
        <Paper
            elevation={0}
            sx={{
                px: '12px',
                py: '24px',
                borderRadius: '10px',
                backgroundColor: '#ffffff'
            }}
        >

            {/* Icon + Title */}
            <Box display="flex" gap={1} alignItems="center" mb="12px">
                <Box sx={{
                    width: '15px',
                    height: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#000000'
                }}>
                    {iconSvg}
                </Box>

                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#636363',
                    }}
                >
                    {title}
                </Typography>
            </Box>

            {/* Rank display */}
            <Box display="flex" flexDirection="row" alignItems="baseline">
                <Box display="flex" flexDirection="row" alignItems="baseline" gap={0.5} mr={1}>
                    <Typography sx={{
                        fontSize: '24px',
                        fontWeight: 700,
                        color: '#2666BE',
                    }}>
                        {rank}
                    </Typography>
                    <Typography sx={{
                        fontSize: '24px',
                        fontWeight: 500,
                        color: '#8d9593'
                    }}>
                        / {total}
                    </Typography>
                </Box>


                <Box>
                    <Typography sx={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#3a3a3a'
                    }}>
                        {label}
                    </Typography>
                </Box>

            </Box>



        </Paper>
    )
}

export default RankingCard;